module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('ci-icon', {
    attrs: {
      "status": _vm.status
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ci-status-text"
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/git/gitlab/~/vue-loader/lib/template-compiler?{"id":"data-v-6cf2e500"}!/home/git/gitlab/~/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/job_name_component.vue
// module id = ub10
// module chunks = 6